import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-50">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Tenarai logo */}
        <img
          src="/assets/tenarai.png"
          alt="Tenarai logo"
          className="mx-auto h-8 w-auto mb-4"
        />
        <h1
          className="text-center text-3xl font-light italic text-gray-900"
          style={{
            fontFamily: "'Georgia', 'Garamond', 'Times New Roman', serif",
            letterSpacing: '0.05em'
          }}
        >
          Pulse
        </h1>
        <p className="mt-2 text-center text-sm text-gray-600">
          Intelligent Cloud Monitoring & Remediation Platform
        </p>
      </div>

      <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
      
      {/* Footer */}
      <footer className="mt-8">
        <p className="text-center text-sm text-gray-500">
          © Copyright Tenarai
        </p>
      </footer>
    </div>
  );
};

export default AuthLayout; 